import * as yup from 'yup';
import { yupUtils, isValidYupSchema } from '../../utils/yup/utils';
import { ProjectErrorType, ProjectErrors } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { DailyMissionTemplate, LevelDefinition, MISSION_TARGET_TYPES } from '../types/progress';

export const MinimalDailyMissionTemplateSchema = yup.object().shape({
  title: yupUtils.stringRequired('The mission title is required'),
  targetType: yupUtils.stringRequiredOneOf(MISSION_TARGET_TYPES),
  targetValue: yupUtils.numberRequired,
  order: yupUtils.numberRequired,
  isActive: yupUtils.booleanRequired,
});

export const DailyMissionTemplateSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  title: yupUtils.stringRequired('The mission title is required'),
  targetType: yupUtils.stringRequiredOneOf(MISSION_TARGET_TYPES),
  targetValue: yupUtils.numberRequired,
  order: yupUtils.numberRequired,
  isActive: yupUtils.booleanRequired,
});

export const parseDailyMissionTemplate = async (object: any): Promise<DailyMissionTemplate | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(DailyMissionTemplateSchema, object)) {
      return object as DailyMissionTemplate;
    }
    return getProjectErrorForCode(ProjectErrors.invalidDailyMissionTemplate);
  } catch (error) {
    console.log(`[DAILY MISSION TEMPLATES] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseDailyMissionTemplates = async (items: any): Promise<DailyMissionTemplate[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[DAILY MISSION TEMPLATES] Error: No array found.');
    return [];
  }

  const data: DailyMissionTemplate[] = [];
  for (const item of items) {
    const o = await parseDailyMissionTemplate(item);
    if (o && !isProjectError(o)) {
      data.push(o as DailyMissionTemplate);
    }
  }

  return data;
};

export const MinimalLevelDefinitionSchema = yup.object().shape({
  level: yupUtils.numberRequired,
  title: yupUtils.stringRequired('The level title is required'),
  minPoints: yupUtils.numberRequired,
});

export const LevelDefinitionSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  level: yupUtils.numberRequired,
  title: yupUtils.stringRequired('The level title is required'),
  minPoints: yupUtils.numberRequired,
});

export const parseLevelDefinition = async (object: any): Promise<LevelDefinition | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(LevelDefinitionSchema, object)) {
      return object as LevelDefinition;
    }
    return getProjectErrorForCode(ProjectErrors.invalidLevelDefinition);
  } catch (error) {
    console.log(`[LEVEL DEFINITIONS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseLevelDefinitions = async (items: any): Promise<LevelDefinition[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[LEVEL DEFINITIONS] Error: No array found.');
    return [];
  }

  const data: LevelDefinition[] = [];
  for (const item of items) {
    const o = await parseLevelDefinition(item);
    if (o && !isProjectError(o)) {
      data.push(o as LevelDefinition);
    }
  }

  return data;
};
